/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState, useEffect, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";
import DialogContent from "@mui/material/DialogContent";

import Grid from "@mui/material/Grid";
import Input from "../../../component/inputpm";
import TextField from "@mui/material/TextField";
import Loader from "../../../component/loader";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import { withTranslation } from "react-i18next";
import { Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Draggable from "react-draggable";
import { Paper, Tooltip } from "@mui/material";
// import { makeStyles } from '@mui/styles';

const EditContract = (props) => {
  const [data, setData] = useState({});
  const t = props.t;
  const [date, setDate] = useState(new Date());
  const [today, setToday] = useState(
    `${date.getFullYear()}-${date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1}-${date.getDate()}`,
  );
  const [providerTypeList, setProviderType] = useState([
    { title: t("SALES_CHANNEL_PROVIDER"), id: "SALES_CHNL_PROVIDER" },
    { title: t("SOLUTION_PROVIDER"), id: "SOLUTION_PROVIDER" },
    { title: t("SERVICE_PROVIDER"), id: "SERVICE_PROVIDER" },
  ]);
  const [providerList, setProvider] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState({
  //     error: false,
  //     message: ''
  // });
  // const styles = makeStyles({
  //     resizablePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 640,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '60vw',
  //     },
  // });
  // const jssClasses = styles();

  useEffect(() => {
    if (props.contractData.partyToType === "SALES_CHNL_PROVIDER") {
      setProvider(props.salesChannelProvidersList);
    } else if (props.contractData.partyToType === "SOLUTION_PROVIDER") {
      setProvider(props.solutionProvidersList);
    } else if (props.contractData.partyToType === "SERVICE_PROVIDER") {
      setProvider(props.serviceProvidersList);
    }
    let tempContractData = { ...props.contractData };
    if (tempContractData.partyToId === "") {
      tempContractData.partyToId = "all";
    }
    setData(tempContractData);
  }, []);

  const onChange = (e) => {
    setError({
      error: false,
      message: "",
    });
    if (e.target.name === "partyToType") {
      if (e.target.value === "SALES_CHNL_PROVIDER") {
        setProvider(props.salesChannelProvidersList);
      } else if (e.target.value === "SOLUTION_PROVIDER") {
        setProvider(props.solutionProvidersList);
      } else if (e.target.value === "SERVICE_PROVIDER") {
        setProvider(props.serviceProvidersList);
      }
      setData({
        ...data,
        [e.target.name]: e.target.value,
        partyToId: "",
      });
    } else {
      setData({
        ...data,
        [e.target.name]: e.target.value,
      });
    }
  };

  const validateForm = () => {
    let val = data.title.trim();
    const error = {};
    if (!data.title || val === "") {
      error.title = t("CONTRACT_TITLE_IS_REQUIRED");
    }
    if (!data.partyToType) {
      error.partyToType = t("RECEPIENT_PROVIDER_TYPE_IS_REQUIRED");
    }
    if (!data.effectiveDate) {
      error.effectiveDate = t("EFFECTIVE_DATE_IS_REQUIRED");
    }
    setError(error);
    if (Object.keys(error).length === 0) {
      return true;
    }
    // if (!data.title || val === '') {
    //     setError({
    //         error: true,
    //         message: t('CONTRACT_TITLE_IS_REQUIRED')
    //     })
    // } else if (!data.partyToType) {
    //     setError({
    //         error: true,
    //         message: t('Recepient Provider Type is required')
    //     })
    // } else if (!data.effectiveDate) {
    //     setError({
    //         error: true,
    //         message: t('EFFECTIVE_DATE_IS_REQUIRED')
    //     })
    // } else {
    //     return true
    // }
  };

  const closeContractModal = (val) => {
    let newData = { ...data };
    if (newData.partyToId === "all") {
      newData.partyToId = "";
    }
    if (val) {
      if (validateForm()) {
        props.close(data);
      }
    } else {
      props.close();
    }
  };

  const [error, setError] = useState({});
  return (
    <>
      <Dialog
        disableScrollLock={true}
        open={props.open}
        maxWidth="lg"
        fullWidth={true}
        PaperComponent={DraggableDialogPaper}
        // PaperProps={{
        //     className: jssClasses.resizablePaper
        // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "99%" }}>
              {t("UPDATE_CONTRACT")}
            </span>
            <Tooltip title={t("CLOSE")}>
              <IconButton
                onTouchStart={(event) => closeContractModal(false)}
                onClick={(event) => closeContractModal(false)}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent style={{ overflowY: "initial" }} dividers>
          <Grid container spacing={3}>
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <Input
                error={!!error.title}
                helperText={error.title}
                name={"title"}
                size={"small"}
                variant={"outlined"}
                value={data.title}
                placeholder={t("CONTRACT_TITLE") + " *"}
                onChange={(event) => onChange(event)}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <Input
                size={"small"}
                variant={"outlined"}
                name={"description"}
                value={data.description}
                onChange={(event) => onChange(event)}
                placeholder={t("CONTRACT_DESCRIPTION")}
              />
            </Grid>

            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <FormControl
                size={"small"}
                variant={"outlined"}
                className={"custom-select-input"}
                error={!!error.partyToType}
              >
                <InputLabel>{t("RECEPIENT_PROVIDER_TYPE")} *</InputLabel>
                <Select
                  native
                  label="RECEPIENT_PROVIDER_TYPE"
                  name={"partyToType"}
                  value={data.partyToType}
                  onChange={(event) => onChange(event)}
                >
                  <option value=""></option>
                  {providerTypeList.map(
                    (opt, key) =>
                      props.providerType !== opt.id && (
                        <option key={key} value={opt.id}>
                          {opt.title}
                        </option>
                      ),
                  )}
                </Select>
                {error.partyToType && (
                  <span
                    style={{
                      color: "#f44336",
                      marginLeft: "0px",
                      fontSize: "0.75rem",
                      marginTop: "4px",
                    }}
                  >
                    {error.partyToType}
                  </span>
                )}
              </FormControl>
            </Grid>
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <FormControl
                size={"small"}
                variant={"outlined"}
                className={"custom-select-input"}
              >
                <InputLabel>{t("RECEPIENT_PROVIDER")}</InputLabel>
                <Select
                  native
                  label="RECEPIENT_PROVIDER"
                  name={"partyToId"}
                  value={data.partyToId}
                  onChange={(event) => onChange(event)}
                >
                  <option value="all">All</option>
                  {providerList.map((opt, key) => (
                    <option key={key} value={opt.id}>
                      {opt.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <TextField
                error={!!error.effectiveDate}
                helperText={error.effectiveDate}
                name="effectiveDate"
                id="date"
                type="date"
                value={data.effectiveDate}
                label={t("CONTRACT_EFFECTIVE_DATE") + " *"}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => onChange(event)}
                inputProps={{ max: data.expiryDate }}
                size={"small"}
                variant={"outlined"}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <TextField
                name="expiryDate"
                id="date"
                type="date"
                value={data.expiryDate}
                label={t("CONTRACT_EXPIRY_DATE")}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => onChange(event)}
                inputProps={{ min: data.effectiveDate }}
                size={"small"}
                variant={"outlined"}
              />
            </Grid>
            {error.error && (
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                {error.message}
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={event => closeContractModal(false)} color="primary">{t('CANCEL')}</Button> */}
          <Button onClick={(event) => closeContractModal(true)} color="primary">
            {t("UPDATE")}
          </Button>
        </DialogActions>
      </Dialog>
      <Loader loading={loading} />
    </>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

export default withTranslation("translations")(EditContract);
